<template>
  <div class="sample-images">
    <div class="images-container">
      <div class="image-item" v-for="(item, index) in listImage" :key="index">
        <el-image
          style="width: 100%; height: 100%"
          fit="cover"
          :src="item.originImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="listImageView"
        >
          <div slot="error">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100%; height: 100%"
            />
          </div>
        </el-image>
        <span class="default-icon" v-if="item.isDefaultImage">
          <i class="el-icon-success"></i>
        </span>
      </div>
      <div v-if="listImage.length === 0" class="no-image">
        <img
          src="/image/static/img/nopic.jpg"
          style="width: 120px; height: 120px"
        />
        <p>{{ $l("tips_no_image") || "暂无图片" }}</p>
      </div>
    </div>

    <!-- Edit Dialog -->
    <el-dialog
      :title="$l('dialog_title_edit_image') || '编辑图片'"
      :visible.sync="editDialogVisible"
      width="800px"
      append-to-body
    >
      <div class="edit-images-container">
        <div class="upload-section">
          <el-upload
            ref="uploader"
            multiple
            action="/oss/ossUploadReturnUrlAndFileId"
            :file-list="listImageFile"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onImageChange"
            accept=".jpeg,.jpg,.png,.gif"
          >
            <el-button size="small" type="primary">
              {{ $l("btn_upload_image") || "上传图片" }}
            </el-button>
          </el-upload>
        </div>
        <div class="d-flex flex-wrap">
          <vuedraggable
            @end="draggableEnd"
            tag="div"
            draggable=".draggable-item"
            class="d-flex flex-wrap"
          >
            <div
              class="draggable-item"
              v-for="(item, index) in listImage"
              :key="index"
            >
              <el-tooltip
                placement="top"
                :content="$l('tips_mouse_drag') || '鼠标点击拖动'"
              >
                <div class="image-box">
                  <span class="default-icon" v-if="item.isDefaultImage">
                    <i class="el-icon-success"></i>
                  </span>
                  <el-image
                    style="width: 100%; height: 100%"
                    fit="scale-down"
                    :src="item.originImageUrl"
                    :preview-src-list="listImageView"
                  ></el-image>
                  <div
                    class="shadow d-flex align-items-center justify-content-center"
                  >
                    <div>
                      <span @click="onImagePreview(index)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span @click="onImageCheck(index)" class="ml-2">
                        <i class="el-icon-check"></i>
                      </span>
                      <span @click="onImageDel(index)" class="ml-2">
                        <i class="el-icon-delete-solid"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </vuedraggable>
        </div>
      </div>
      <div
        v-show="false"
        ref="imagesViewer"
        class="imagesViewer"
        v-viewer="{ movable: true }"
      >
        <img
          v-for="(item, index) in listImage"
          :src="item.originImageUrl || '/image/static/img/nopic.jpg'"
          :key="index"
        />
      </div>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button type="primary" @click="editDialogVisible = false">
          {{ $l("INDEX.product_dialog_btn_confirm") || "确定" }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from "@/mixins/edit-loading";
import vuedraggable from "vuedraggable";
export default {
  mixins: [EditLoading],
  props: {
    materialCode: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { vuedraggable },
  data() {
    return {
      listImage: [],
      editDialogVisible: false,
      listImageFile: [],
      uploadFileMaxLimit: 8,
    };
  },
  computed: {
    listImageView() {
      return this.listImage.map((image) => {
        return image.originImageUrl;
      });
    },
    isEmpty() {
      return !this.listImageFile || !this.listImageFile.length;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.materialCode) return;
      this.getImageData();
    },
    getImageData() {
      this.$api
        .materialInfoImageListApi({ materialCode: this.materialCode })
        .then((res) => {
          this.listImage = res.body.data;
        });
    },
    openEditDialog() {
      if (!this.materialCode) {
        this.$alert(
          this.$l("tips_save_basic_info_first") || "请先保存基本信息",
          this.$l("INDEX.label_completeDesc") || "提示",
          {
            confirmButtonText:
              this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          }
        );
        return;
      }
      this.editDialogVisible = true;
    },
    clearFiles() {
      this.$refs.uploader.clearFiles();
      this.listImageFile = [];
    },
    onImageChange(file) {
      if (file.status !== "ready") return;

      const $uploader = this.$refs.uploader;
      const uploader = $uploader.$el.querySelectorAll("input")[0];

      const listFile = uploader.files;
      const fileCount = listFile.length;

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`;
        this.$message.warning(msg);
        this.clearFiles();
        throw new Error(msg);
      }
      this.listImageFile.push(file);
      if (this.listImageFile.length !== fileCount) return false;
      this.upload();
    },
    async upload() {
      if (this.isEmpty) {
        this.$message.warning("请选择您需要上传的图片！");
        return;
      }
      this.loadingOpen();
      const listImage = await this.uploadImages();
      const params = { materialCode: this.materialCode, listImage };
      this.uploadInfoSave(params)
        .then((res) => {
          this.loadingClose();
          this.clearFiles();
          const { status } = res;
          if (status !== 200) {
            this.$message.error("上传失败");
            return;
          }
          this.getImageData();
        })
        .catch(() => {
          this.clearFiles();
          this.loadingClose();
          this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        });
    },
    uploadImages() {
      if (this.isEmpty) return Promise.resolve([]);
      const uploadTask = this.listImageFile.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          originImageCode: res.body.fileId,
          originImageUrl: res.body.url,
          originImageSpec: image.raw.type,
          uid: image.uid,
        }));
      });
      return Promise.all(uploadTask);
    },
    async uploadInfoSave(params) {
      if (this.isEmpty) {
        this.$message.warning(`请选择您需要上传的资料！`);
        return;
      }
      return await this.$api.materialInfoImageBatchUploadApi(params);
    },
    onImagePreview(index) {
      if (!this.listImage.length) return;

      this.$nextTick(() => {
        // Since the dialog uses append-to-body, we need to search in document body
        const viewerEl =
          document.querySelector(".imagesViewer") || this.$refs.imagesViewer;
        if (!viewerEl || !viewerEl.$viewer) {
          console.warn("Viewer element not found or not initialized");
          return;
        }
        const viewer = viewerEl.$viewer;
        viewer.view(index);
        viewer.show();
      });
    },
    onImageCheck(index) {
      const image = this.listImage[index];
      const params = {
        materialCode: this.materialCode,
        materialImgCode: image.materialImgCode,
      };
      this.$api.setMaterialInfoDefaultImageApi(params).then(() => {
        this.$message({
          showClose: true,
          message: "设置成功！",
          type: "success",
        });
        this.getImageData();
        this.$emit("reload");
      });
    },
    onImageDel(index) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        const image = this.listImage[index];
        const params = { materialImgCode: image.materialImgCode };
        this.loadingOpen();
        this.imageDel(params)
          .then((res) => {
            this.loadingClose();
            const { status } = res;
            if (status === 200) {
              this.getImageData();
              this.$emit("reload");
            } else {
              this.$message.error(
                this.$l("INDEX.tips_delete_no") || "删除失败！"
              );
            }
          })
          .catch(() => {
            this.loadingClose();
            this.$message.error(
              this.$l("INDEX.tips_delete_no") || "删除失败！"
            );
          });
      });
    },
    async imageDel(params) {
      return await this.$api.materialInfoImageDelApi(params);
    },
    reloadImages() {
      this.listImage = [];
      this.getImageData();
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (newIndex === oldIndex) return;
      const oldEl = { ...this.listImage[oldIndex] };
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listImage[i] = this.listImage[i - 1];
        }
      } else if (newIndex > oldIndex) {
        for (let i = oldIndex; i < newIndex; i++) {
          this.listImage[i] = this.listImage[i + 1];
        }
      }
      this.listImage[newIndex] = oldEl;
      this.updateSortOrder(this.listImage);
    },
    updateSortOrder(params) {
      this.loadingOpen();
      this.updateOrder(params)
        .then((res) => {
          this.loadingClose();
          const { status } = res;
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_operate_ok") || "操作成功！",
              type: "success",
            });
            this.reloadImages();
          } else {
            this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
          }
        })
        .catch(() => {
          this.loadingClose();
          this.$message.error(this.$l("INDEX.tips_save_no") || "保存失败！");
        });
    },
    async updateOrder(params) {
      return await this.$api.materialInfoImageUpdateSortOrderApi({
        listImage: params,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sample-images {
  .images-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    min-height: 200px;
  }

  .image-item {
    width: 120px;
    height: 120px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    .default-icon {
      position: absolute;
      z-index: 999;
      right: 4px;
      top: 4px;
      color: #67c23a;
      font-size: 16px;
    }
  }

  .no-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: #909399;
    font-size: 14px;
  }

  .no-data-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 40px 0;
    color: #e6a23c;
    font-size: 14px;

    i {
      font-size: 48px;
      margin-bottom: 12px;
    }

    p {
      margin: 0;
    }
  }
}

.edit-images-container {
  .upload-section {
    margin-bottom: 16px;
  }
}

.image-box {
  width: 120px;
  height: 120px;
  line-height: 120px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;

  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}

.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
  cursor: pointer;
}
</style>
